import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addCustomerTag, getCustomerTag, updateCustomerTag } from "./CustomerTagRepository";


export const useCustomerTagListData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["CUSTOMER_TAG", params],
        queryFn: () => getCustomerTag(params),
        enabled: enable,
        retry: false,
    });
};

export const useAddCustomerTag = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addCustomerTag,
        onSuccess: (data) => {
            toast.success("Customer Tag Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["CUSTOMER_TAG"] });
        },
        onError: (error) => {
            toast.error("Failed to Add Customer Tag!");
        },
    });
};
export const useUpdateCustomerTag = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({  body }: {  body: any }) =>
            updateCustomerTag(body),
        onSuccess: (data) => {
            toast.success("Update Customer Tag Successfully!");
            queryClient.invalidateQueries({ queryKey: ["CUSTOMER_TAG"] });
        },
        onError: (error) => {
            toast.error("Failed to Update Customer Tag!");
        },
    });
};

